// extracted by mini-css-extract-plugin
export default {"select":"TagsInput_select__+gt7D","invalidTag":"TagsInput_invalidTag__lwW6-"};